import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Row, Input, Card, CardBody, CardTitle, Button, Modal, ModalHeader, ModalBody } from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import IntlMessages from '../../../../../../helpers/IntlMessages';
import {
  faCommentDots,
  faEdit,
  faTrashAlt,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import {
  putAPI_Update_Response,
  postAPI_Create_A_Message,
} from '../../../../../../constants/APIs';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import Validation from '../../../../../../components/Validation';

function Message({
  reloadBotResponse,
  code,
  type,
  msg,
  messages,
  example,
  apiCollections,
  isExample,
  index,
  isAdd,
  setIsAddMsgToFalse,
  numberOfMsg,
  /** for message-link type */
  link,
  caption,
  /** for message-image-carousel type */
  urls,
  captions,
  /** Globle property id from redux */
  propertyId,
  child,
  SaveRecommenderQuestionCode,
  locale,
  viewResponse,
  selectedLang,
  historyUpdator,
  isButtonShow
}) {
  const [isEditing, setIsEditing] = useState(false);
  const [messageInput, setMessageInput] = useState(msg);
  const [open, setOpen] = useState(false);
  const [msgs, setMsgs] = useState([]);
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [postData, setPostData] = useState({
    GroupId: getGroupID(),
    Code: code,
    Language: `${selectedLang === 'en' ? 'en-US' : selectedLang}`,
    Channel: 'WebsiteDirectLine',
    PropertyId: propertyId === "-1" ? null : propertyId,
    Default: null,
    Overrides: {},
    UserName: historyUpdator
  });

  const handleEdit = () => {
    setIsEditing(true);
  };
  const toggle = () => {
    setDeleteVisible(!deleteVisible);
  };


  const handleDelete = () => {
    //console.log(postData)
    if (type === 'messages') {
      postData.Default.splice(index, 1);
    }
    else { postData.Default.Messages.splice(index, 1); }

    // console.log(type)

    try {
      AxiosAPI({
        method: 'put',
        url: putAPI_Update_Response,
        data: postData,
      })
        .then((res) => {
          if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
            && res.data.Messages !== null && res.data.Messages.length > 0) {
            setMsgs(res.data.Messages);
            setOpen(true);
          }
          else {
            setIsEditing(false);
            toggle();
            setTimeout(() => {
              reloadBotResponse();
            }, 1000)
          }
        })
        .finally(

      );
    } catch (error) {
      console.error(error);
    }
  }

  const handleTextChange = e => {
    setMessageInput(e.target.value);
  };

  const changeTrim = (text) => {
    var messages = "";
    if (text !== null) {
      var message = text;
      const regExp = /\(([^)]+)\)/g;
      const matchesBracket = [...text.matchAll(regExp)].flat();
      var matchesText = "";
      var bracket1 = "";
      if (matchesBracket !== null && matchesBracket.length > 0) {
        matchesText = matchesBracket[0];
        bracket1 = matchesBracket[0].trim().replace(/\s+/g, '').toLowerCase();
      }
      var matched = text.match("\\[.*]");
      var bracket2 = "";
      var matchedText = "";
      if (matched !== null) {
        matchedText = matched[0];
        bracket2 = matched[0].trim().replace(/\s+/g, '').toLowerCase();
      }
      console.log("[]:", matchedText, bracket2);
      var isReplace = false;
      if (!isNaN(bracket1) || !isNaN(bracket2)) {
        isReplace = true;
      }
      console.log(isReplace);
      if (isReplace) {
        message = text.replace(matchesText, bracket1).replace(matchedText, bracket2);
      }
      console.log(message);
      messages = message;
    }
    return messages;
  }

  useEffect(() => {
    console.log(152, type, apiCollections);
    if (type === 'messages' || 'example') {
      setPostData(pre => {
        const arr = [...messages];
        arr[index] = messageInput || example;
        return { ...pre, Default: arr };
      });
    }
    // console.log('Message Post Data', postData);
    if (type === 'messages-link') {
      setPostData(pre => {
        const arr = [...messages];
        arr[index] = messageInput || example;
        return {
          ...pre,
          Default: {
            Messages: arr,
            Url: link,
            Caption: caption,
          },
        };
      });
    }
    if (type === 'invokeApi') {
      setPostData(pre => {
        const arr = [...messages];
        arr[index] = messageInput || example;
        return {
          ...pre,
          Default: {
            Messages: arr,
            ApiCollection: apiCollections,
          },
        };
      });
    }
    if (type === 'messages-image-carousel') {
      setPostData(pre => {
        const arr = [...messages];
        arr[index] = messageInput || example;
        const imageList = urls.map((url, index) => {
          const imgCaption = captions[index];
          return { Url: url, Caption: imgCaption };
        });
        return {
          ...pre,
          Default: {
            Messages: arr,
            Images: imageList,
          },
        };
      });
    }
    if (type === 'messages-video') {
      setPostData(pre => {
        const arr = [...messages];
        arr[index] = messageInput || example;
        const videoList = urls.map((url, index) => {
          const videoCaption = captions[index];
          return { Url: url, Caption: videoCaption };
        });
        return {
          ...pre,
          Default: {
            Messages: arr,
            Videos: videoList,
          },
        };
      });
    }
  }, [messageInput]);

  const handleSave = async () => {
    /** Create a new message */
    // if (type === 'example') {
    //   try {
    //     return await AxiosAPI({
    //       method: 'post',
    //       url: postAPI_Create_A_Message,
    //       data: postData,
    //     })
    //       .then(() => {
    //         setIsEditing(false);
    //         if (setIsAddMsgToFalse) {
    //           setIsAddMsgToFalse();
    //         }
    //       })
    //       .finally(
    //         setTimeout(() => {
    //           if (SaveRecommenderQuestionCode !== undefined) {
    //             SaveRecommenderQuestionCode();
    //           }
    //           else {
    //             reloadBotResponse();
    //           }
    //         }, 1000)
    //       );
    //   } catch (error) {
    //     console.error(error);
    //   }
    // }

    /** Update a message when the response's type is "messages" */
    if (type === 'messages' || 'messages-link' || 'messages-image-carousel' || 'messages-video' || 'invokeApi') {
      try {
        return await AxiosAPI({
          method: 'put',
          url: putAPI_Update_Response,
          data: postData,
        }).then(res => {
          if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
            && res.data.Messages !== null && res.data.Messages.length > 0) {
            setMsgs(res.data.Messages);
            setOpen(true);
          }
          else {
            setIsEditing(false);
            //toggle();
            setTimeout(() => {
              if (SaveRecommenderQuestionCode !== undefined) {
                SaveRecommenderQuestionCode();
              }
              else {
                reloadBotResponse();
              }
            }, 1000);
          }
        })
          .finally(

        );
      } catch (error) {
        console.error(error);
      }
    }
  };

  const handleCancel = () => {
    setIsEditing(false);
    if (setIsAddMsgToFalse) {
      setIsAddMsgToFalse();
    }
  };

  const Showing = () => {
    return (
      <Fragment>
        <CardTitle>
          <Row>
            <Colxx xxs="8">
              <FontAwesomeIcon icon={faCommentDots} />
              <span> </span>
              <IntlMessages id="property.message" />
            </Colxx>
            {viewResponse !== true && isButtonShow &&
              <Colxx xxs="4">
                <div className="float-right">
                  <FontAwesomeIcon
                    icon={faEdit}
                    color="#90caf9"
                    cursor="pointer"
                    onClick={handleEdit}
                  />
                  {numberOfMsg > 1 ? (
                    <Fragment>
                      <b> | </b>
                      <FontAwesomeIcon
                        icon={faTrashAlt}
                        style={{ color: 'var(--theme-color-1)' }}
                        cursor="pointer"
                        onClick={toggle}
                      />
                    </Fragment>
                  ) : (
                    <Fragment>
                      <b> | </b>
                      <FontAwesomeIcon
                        icon={faTrashAlt}
                        color="#eee"
                        cursor=" not-allowed"
                      />
                    </Fragment>
                  )}
                </div>
              </Colxx>
            }
          </Row>
        </CardTitle>
        <Row>
          <Colxx xxs="12">
            {messageInput ? (
              <p>{messageInput}</p>
            ) : (
              <p style={{ color: 'red' }}>This is an example {example}</p>
            )}
          </Colxx>
        </Row>
        <Modal isOpen={deleteVisible} toggle={toggle}>
          <ModalHeader toggle={toggle}>
            <span role="img" aria-label="warning">
              ⚠️
            </span>
            This response will be deleted!
          </ModalHeader>
          <ModalBody>
            <Button
              color="danger"
              onClick={() => handleDelete()}
              size="xs"
            >
              Delete
            </Button>
            <Button
              className="ml-2"
              color="dark"
              outline
              size="xs"
              onClick={toggle}
            >
              Cancel
            </Button>
          </ModalBody>
        </Modal>
      </Fragment>
    );
  };

  const Editing = () => {
    return (
      <Fragment>
        <CardTitle>
          <Row style={{ textAlign: 'left' }}>
            <Colxx xxs="6">
              <div>
                <FontAwesomeIcon icon={faCommentDots} />
                <span> </span>
                <IntlMessages id="property.message" />
              </div>
            </Colxx>
            <Colxx xxs="6">
              <div className="float-right">
                <Button
                  color="secondary"
                  className="add-button"
                  size="xs"
                  onClick={handleSave}
                >
                  Save
                </Button>
                <b> </b>
                <Button
                  color="light"
                  className="add-button"
                  size="xs"
                  onClick={handleCancel}
                >
                  Cancel
                </Button>
              </div>
            </Colxx>
          </Row>
        </CardTitle>
        <Row>
          <Colxx xxs="12">
            <Input
              type="textarea"
              defaultValue={
                messageInput
                  ? messageInput
                  : `${child === undefined ? '{ This is an example }' : ''} ${example}`
              }
              onChange={handleTextChange}
            />
          </Colxx>
        </Row>
      </Fragment>
    );
  };

  return (
    <Card>
      <CardBody>{isEditing || isAdd ? Editing() : Showing()}
        <Validation open={open} messages={msgs} toggle={() => { setOpen(!open) }}></Validation>
      </CardBody>
    </Card>
  );
}

Message.propTypes = {
  code: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  msg: PropTypes.string,
  messages: PropTypes.array,
  example: PropTypes.string,
  index: PropTypes.number,
  isAdd: PropTypes.bool,
  setIsAddMsgToFalse: PropTypes.func,
  link: PropTypes.string,
  caption: PropTypes.string,
};

const mapStateToProps = ({ settings }) => {
  const { propertyId, locale } = settings;
  return {
    propertyId,
    locale
  };
};

export default injectIntl(connect(mapStateToProps)(Message));
